// Patient overview section form field enum
export enum PatientOverviewFormField {
  // Demographics
  PATIENT_OVERVIEW_LEGAL_NAME = 'patient-overview/legal-name',
  PATIENT_OVERVIEW_PREFERRED_NAME = 'patient-overview/preferred-name',
  PATIENT_OVERVIEW_DATE_OF_BIRTH = 'patient-overview/date-of-birth',
  PATIENT_OVERVIEW_ADDRESS = 'patient-overview/address',
  PATIENT_OVERVIEW_GENDER = 'patient-overview/gender',
  PATIENT_OVERVIEW_SEX = 'patient-overview/sex',
  PATIENT_OVERVIEW_DEMOGRAPHICS_MEDICAID_ID = 'patient-overview/medicaid-id',

  // Care Team
  PATIENT_OVERVIEW_ORDERING_PRACTITIONER = 'patient-overview/ordering-practitioner',
  PATIENT_OVERVIEW_DISCHARGE_ASSESSMENT_STATUS = 'patient-overview/discharge-assessment-status'
}
